
import '../App.css';
import Header from '../components/Header';
import Hero from "../components/Hero";
import Announcement from "../components/Announcement";
import AboutUs from '../components/AboutUs';
import LibraryMembers from '../components/LibraryMembers';
import History from "../components/History";
import StateSection from "../components/StateSection";
import EventSection from "../components/EventSection";
import DonationBanner from '../components/DonationBanner';
import Testimonial from '../components/Testimonial';
import Certificates from '../components/Certificates';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <Hero/>
    <Announcement/>
    <AboutUs/>
    <LibraryMembers/>
    <History/>
    <StateSection/>
    <EventSection/>
    <DonationBanner/>
    <Testimonial/>
    <Certificates/>
    <Footer/>
    </div>
  );
}

export default App;
